import { render, staticRenderFns } from "./EventDetectionHRDataTable.vue?vue&type=template&id=07cefdd5&scoped=true"
import script from "./EventDetectionHRDataTable.vue?vue&type=script&lang=js"
export * from "./EventDetectionHRDataTable.vue?vue&type=script&lang=js"
import style0 from "./EventDetectionHRDataTable.vue?vue&type=style&index=0&id=07cefdd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cefdd5",
  null
  
)

export default component.exports